import React, { Component } from 'react';
import CurrentUserContext from './CurrentUserContext';
import LogRocket from 'logrocket';
class CurrentUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      handleSetUser: this.handleSetUser,
    };
  }

    handleSetUser = (user) => {
      if (user != null) {
        LogRocket.identify(user.email)
        this.setState({ currentUser: user });
      }
    }

    render() {
      return (
        <CurrentUserContext.Provider
          value={
            this.state
          }
        >
          {this.props.children}
        </CurrentUserContext.Provider>
      );
    }
}

export default CurrentUser;
